import { useNavigate } from 'react-router-dom'
import { formatPhoneNumber, getPartOfDay } from './extensions'
import { company, customerData } from './CustomerData'

import stageHistoryIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/stageHistoryIcon.png'
import documentsCenterIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/documentsCenterIcon.png'
import resourceCenterIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/resourceCenterIcon.png'
import qaIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/q&aIcon.png'
import contactUsIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/contactUsIcon.png'
import referAFriend from '../assets/DashboardIcons/DashboardSidePanelIcons/referAFriendIcon.png'
import calenderIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/calenderIcon.png'
import discountIcon from '../assets/DashboardIcons/DashboardSidePanelIcons/discountIcon.png'

export default function MobileSideBar({ showMobileSideBar, setShowMobileSideBar, activeTab, setActiveTab }) {
  const navigate = useNavigate()
  const sidebarClass = showMobileSideBar ? 'translate-x-0' : '-translate-x-full'

  const getTabClasses = (tabIndex, haveMargin) => {
    let baseClasses = `flex w-full h-12 p-2 rounded-md items-center cursor-pointer transition-colors duration-300 ${haveMargin && 'mb-4'}`
    let hoverClasses = tabIndex % 2 === 0 ? 'hover:bg-primaryColor hover:bg-opacity-50 hover:text-white' : 'hover:bg-secondaryColor hover:bg-opacity-25 hover:text-white'
    if (activeTab === tabIndex) {
      return `${baseClasses} ${tabIndex % 2 === 0 ? 'bg-primaryColor text-white' : 'bg-secondaryColor text-white'} font-bold bg-opacity-50`
    } else {
      return `${baseClasses} ${hoverClasses}`;
    }
  }

  return (
    <div className={`fixed top-0 left-0 w-72 h-full shadow-lg transform ${sidebarClass} transition-transform duration-300 p-6 z-30 overflow-auto bg-white`}>
      <div className='flex justify-between items-center mb-8'>
        <img onClick={() => { setShowMobileSideBar(false); navigate('/dashboard') }} src={company.companyLogoURL} className='w-32 cursor-pointer' />
        <button onClick={() => setShowMobileSideBar(false)} className='text-red-700 hover:text-red-900 transition-colors duration-200'>
          <svg xmlns='http://www.w3.org/2000/svg' className='h-6 w-6' fill='none' viewBox='0 0 24 24' stroke='currentColor'>
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M6 18L18 6M6 6l12 12' />
          </svg>
        </button>
      </div>
      <p className='text-lg font-bold'>{getPartOfDay()}</p>
        <p className='text-3xl font-bold mb-10'>{customerData.customerLeadData.leadContact.contactName}</p>
        <div className='w-full flex flex-row items-center justify-between mb-4'>
          <p className='text-gray-700'>Email:</p>
          <p className='text-gray-500'>{customerData.customerLeadData.leadContact.contactEmail}</p>
        </div>
        <div className='w-full flex flex-row items-center justify-between mb-20'>
          <p className='text-gray-700'>Phone:</p>
          <p className='text-gray-500'>{formatPhoneNumber(customerData.customerLeadData.leadContact.contactPhone)}</p>
        </div>
        <div className='flex flex-col w-full'>
          <div onClick={() => { setShowMobileSideBar(false); setActiveTab(0); document.title = `${company.companyName} | Stage History` }} className={getTabClasses(0, true)}>
            <img className='h-full mr-5' src={stageHistoryIcon} alt='Stage History Icon' />
            <p>Stage History</p>
          </div>
          <div onClick={() => { setShowMobileSideBar(false); setActiveTab(1); document.title = `${company.companyName} | Document Center` }} className={getTabClasses(1, true)}>
            <img className='h-full mr-5' src={documentsCenterIcon} alt='Documents Center Icon' />
            <p>Document Center</p>
          </div>
          <div onClick={() => { setShowMobileSideBar(false); setActiveTab(2); document.title = `${company.companyName} | Resource Center` }} className={getTabClasses(2, true)}>
            <img className='h-full mr-5' src={resourceCenterIcon} alt='Resource Center Icon' />
            <p>Resource Center</p>
          </div>
          <div onClick={() => { setShowMobileSideBar(false); setActiveTab(3); document.title = `${company.companyName} | Q&A Center` }} className={getTabClasses(3, true)}>
            <img className='h-full mr-5' src={qaIcon} alt='Q&A Icon' />
            <p>Q&A</p>
          </div>
          <div onClick={() => { setShowMobileSideBar(false); setActiveTab(4); document.title = `${company.companyName} | Contact Us` }} className={getTabClasses(4, customerData.customerLeadData.leadStage.leadStageId === '4f1fdb1f-4278-4ff7-bde7-c4cd27c10d06' ? true : false)}>
            <img className='h-full mr-5' src={contactUsIcon} alt='Contact Us Icon' />
            <p>Contact Us</p>
          </div>
          {!customerData.customerInvoiceData.invoiceId && (
            <div onClick={() => { setShowMobileSideBar(false); setActiveTab(7); document.title = `${company.companyName} | Discount Code` }} className={getTabClasses(7, true)}>
              <img className='h-full mr-5' src={discountIcon} alt='Discount Code' />
              <p>Discount Code</p>
            </div>
          )}
          {(customerData.customerLeadData.leadType === 'Leads' || customerData.customerLeadData.leadStage.leadStageId === '4f1fdb1f-4278-4ff7-bde7-c4cd27c10d06') && (
            <div onClick={() => { setShowMobileSideBar(false); setActiveTab(6); document.title = `${company.companyName} | Change Days` }} className={getTabClasses(6)}>
              <img className='h-full mr-5' src={calenderIcon} alt='Refer A Friend' />
              <p>Change Days</p>
            </div>
          )}
        </div>
    </div>
  )
}